import React, { useCallback, useContext, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useEventParticipationSubmission } from "../../context/EventParticipationSubmissionManager";
import AuthenticatedUserContext from "../../context/AuthenticatedUserContext";
import CountrySelect from "../../components/profile/CountrySelect";

function EventParticipationNawForm() {
    const { user } = useContext(AuthenticatedUserContext);
    const { eventId } = useParams();
    const history = useHistory();
    const { formData, updateFormData, errors } = useEventParticipationSubmission();
    const [localErrors, setLocalErrors] = useState({});

    useEffect(() => {
        if (!user) {
            return;
        }

        if (user.address) {
            updateFormData("address", user.address);
        }
        if (user.postalCode) {
            updateFormData("postalCode", user.postalCode);
        }
        if (user.city) {
            updateFormData("city", user.city);
        }
        if (user.country) {
            updateFormData("country", user.country);
        }
    }, [user, updateFormData]);


    const validateForm = useCallback(() => {
        const newErrors = {};
        
        if (!formData.address.trim()) {
            newErrors.address = "Adres is verplicht";
        }
        
        if (!formData.postalCode.trim()) {
            newErrors.postalCode = "Postcode is verplicht";
        }
        
        if (!formData.city.trim()) {
            newErrors.city = "Stad is verplicht";
        }
        
        if (!formData.country.trim()) {
            newErrors.country = "Land is verplicht";
        }
        
        setLocalErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }, [formData]);

    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        
        if (validateForm()) {
            // If validation passes, navigate to the next step
            history.push(`/event/${eventId}/participation-submission/vehicle`);
        }
    }, [eventId, history, validateForm]);

    const handleChange = useCallback((event) => {
        const { name, value } = event.target;
        updateFormData(name, value);
        
        // Clear error when user starts typing
        if (localErrors[name]) {
            setLocalErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    }, [localErrors, updateFormData]);

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="mb-0">Persoonlijke gegevens</h3>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="address" className="form-label">Adres</label>
                        <input
                            type="text"
                            className={`form-control ${localErrors.address ? "is-invalid" : ""}`}
                            id="address"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                        />
                        {localErrors.address && (
                            <div className="invalid-feedback">{localErrors.address}</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="postalCode" className="form-label">Postcode</label>
                        <input
                            type="text"
                            className={`form-control ${localErrors.postalCode ? "is-invalid" : ""}`}
                            id="postalCode"
                            name="postalCode"
                            value={formData.postalCode}
                            onChange={handleChange}
                        />
                        {localErrors.postalCode && (
                            <div className="invalid-feedback">{localErrors.postalCode}</div>
                        )}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="city" className="form-label">Woonplaats</label>
                        <input
                            type="text"
                            className={`form-control ${localErrors.city ? "is-invalid" : ""}`}
                            id="city"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                        />
                        {localErrors.city && (
                            <div className="invalid-feedback">{localErrors.city}</div>
                        )}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="country" className="form-label">Land</label>
                        <CountrySelect
                            id="country"
                            name="country"
                            value={formData.country}
                            onChange={(event) => {
                                handleChange({
                                    target: {
                                        id: "country",
                                        name: "country", 
                                        value: event.target.value
                                    }
                                });
                            }}
                            disabled={false}
                        />
                        {localErrors.country && (
                            <div className="invalid-feedback">{localErrors.country}</div>
                        )}
                    </div>

                    {errors.submit && (
                        <div className="alert alert-danger">{errors.submit}</div>
                    )}

                    <div className="d-flex justify-content-between mt-4">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => history.push(`/event/${eventId}/participation-submission`)}
                        >
                            Terug
                        </button>
                        <button type="submit" className="btn btn-primary">
                            Volgende
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EventParticipationNawForm;
